// extracted by mini-css-extract-plugin
export default {"container_about":"about_container_about__i-Kg1","foto":"about_foto__ge2C2","button":"about_button__CUCeO","glowing-button-85":"about_glowing-button-85__TgoiF"};